module.exports = __webpack_public_path__ + "images/handarrow-flipped-456187a3e1f9e792f074238b00f56736.svg";